



































































import { appModule } from "@/store/modules/app";
// import { storePresensi } from "@/store/modules/presensi";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import UnitAutoComplete from "@/components/UnitAutoComplete.vue";
import BedKosongAutoComplete from "@/components/BedKosongAutoComplete.vue";
import DataBed from "@/services/DataBed";
import { storeReferensi } from "@/store/modules/referensi";
import { storeBed } from "@/store/modules/bed";
import { userModule } from "@/store/modules/user";
@Component({
  components: {
    UnitAutoComplete,
    BedKosongAutoComplete,
  },
})
export default class ModalMutasiPasien extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() item!: object;
  // @Prop() bulan: string;
  // jam = "jam";
  // validasi = [(v) => this.cek(v) || this.message()];
  // valid = [(v) => !!v || "*Alasan harus diisi"];
  msg = "";
  unit = {};
  bed = {};
  no = null;

  simpan() {
    const dt = DataBed.mutasiPasien(
      this.item["pasien"].rm,
      this.item["id"],
      this.bed["id"],
      this.user["pegawai_id"],
      this.item["catatan_pasien"]
    );
    dt.then((dt) => {
      if (dt["status"] != 1) {
        appModule.sendErrorAlert(dt["message"]);
      } else {
        appModule.NoticeDelay("Berhasil Mutasi Pasien");
        // storeBed.actBedByUnit(this.item["unit"].id);
        this.close();
      }
    });
  }
  setUnit(val) {
    this.unit = val;
  }
  setBed(val) {
    this.bed = val;
  }

  close() {
    storeBed.actBedByUnit(this.item["unit"].id);
    this.unit = {};
    this.bed = {};
    this.no = null;
    this.show = false;
  }

  message() {
    return this.msg;
  }

  get user() {
    return userModule.user;
  }

  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }

  @Watch("unit")
  watchUnit(val) {
    // alert("change");

    this.bed = {};
    storeReferensi.actBedKosongByUnit(this.unit["id"]);
  }
}
